import { CONTENT_PAGES } from 'features/empty_state'

import { ARTICLE_CONTENT_KEYS } from '../constants'

const buildPlayVideoFlowStepCompletedProps = (context) => ({
  flow_name: `contextual_help_${context}`,
  flow_step: 'play_video',
  completion_method: 'guide_completed',
  flow_step_value: null,
  flow_version: 'v1'
})

// Overview Pages
const adminDashboardOverviewPage = {
  title: ARTICLE_CONTENT_KEYS.ADMIN_CENTER,
  videoId: 't7v4kkldcp',
  playVideoEventProps: buildPlayVideoFlowStepCompletedProps('admin_dashboard'),
  articles: [ARTICLE_CONTENT_KEYS.ADMIN_CENTER],
  helpCenterLink: 'https://calendly.com/help/admin-dashboard',
}

const analyticsOverviewPage = {
  title: ARTICLE_CONTENT_KEYS.ANALYTICS,
  videoId: 'nyb8d4c16k',
  playVideoEventProps: buildPlayVideoFlowStepCompletedProps('analytics_events'),
  articles: [ARTICLE_CONTENT_KEYS.ANALYTICS],
  helpCenterLink: 'https://calendly.com/help/calendly-analytics',
}

const analyticsOverviewCapacityPage = {
  ...analyticsOverviewPage,
  playVideoEventProps: buildPlayVideoFlowStepCompletedProps('analytics_capacity'),
  articles: [ARTICLE_CONTENT_KEYS.ANALYTICS_CAPACITY],
}

const analyticsOverviewRoutingPage = {
  ...analyticsOverviewPage,
  playVideoEventProps: buildPlayVideoFlowStepCompletedProps('analytics_routing'),
  articles: [ARTICLE_CONTENT_KEYS.ANALYTICS_ROUTING],
}

const contactsOverviewPage = {
  title: ARTICLE_CONTENT_KEYS.CONTACTS,
  videoId: 'ln6a4idxfx',
  playVideoEventProps: buildPlayVideoFlowStepCompletedProps('contacts'),
  articles: [ARTICLE_CONTENT_KEYS.CONTACTS],
  helpCenterLink: 'https://calendly.com/help/contacts-overview',
}

const eventTypesOverviewPage = {
  title: ARTICLE_CONTENT_KEYS.EVENT_TYPES,
  videoId: 'vk7ev1bulu',
  playVideoEventProps: buildPlayVideoFlowStepCompletedProps('event_types'),
  articles: [ARTICLE_CONTENT_KEYS.EVENT_TYPES],
  helpCenterLink: 'https://calendly.com/help/event-types-overview',
}

const groupsOverviewPage = {
  title: ARTICLE_CONTENT_KEYS.GROUPS,
  videoId: 'b1b190my1i',
  playVideoEventProps: buildPlayVideoFlowStepCompletedProps('admin_groups'),
  articles: [ARTICLE_CONTENT_KEYS.GROUPS],
  helpCenterLink: 'https://calendly.com/help/groups-overview',
}

const managedEventTypesOverviewPage = {
  title: ARTICLE_CONTENT_KEYS.MANAGED_EVENTS,
  videoId: 'cx6k9ccb88',
  playVideoEventProps: buildPlayVideoFlowStepCompletedProps('admin_managed_events'),
  articles: [ARTICLE_CONTENT_KEYS.MANAGED_EVENTS],
  helpCenterLink: 'https://calendly.com/help/managed-events-overview',
}

const managedWorkflowsOverviewPage = {
  title: ARTICLE_CONTENT_KEYS.MANAGED_WORKFLOWS,
  videoId: 'kkcumxizmn',
  playVideoEventProps: buildPlayVideoFlowStepCompletedProps('admin_managed_workflows'),
  articles: [ARTICLE_CONTENT_KEYS.MANAGED_WORKFLOWS],
  helpCenterLink: 'https://calendly.com/help/workflows-for-admins',
}

const meetingsOverviewPage = {
  title: ARTICLE_CONTENT_KEYS.MEETINGS,
  videoId: '88hhsonn9g',
  playVideoEventProps: buildPlayVideoFlowStepCompletedProps('meetings'),
  articles: [ARTICLE_CONTENT_KEYS.MEETINGS],
  helpCenterLink: 'https://calendly.com/help/how-to-manage-your-meetings',
}
// TODO: Robby update videoId and add ARTICLE_CONTENT_KEYS.RECAPS_SHARE when ready
const recapsOverviewPage = {
  title: ARTICLE_CONTENT_KEYS.RECAPS_SETUP,
  videoId: '7t64tnpv0z',
  playVideoEventProps: buildPlayVideoFlowStepCompletedProps('recaps'),
  articles: [ARTICLE_CONTENT_KEYS.RECAPS_SETUP],
  helpCenterLink: 'https://calendly.com/help/how-to-manage-and-share-notetaker-recaps',
  secondaryLink: `${window.location.origin}/app/tracked_meetings/sample`
}

const routingFormsOverviewPage = {
  title: ARTICLE_CONTENT_KEYS.ROUTING,
  videoId: 'lhgox2l1qv',
  playVideoEventProps: buildPlayVideoFlowStepCompletedProps('routing'),
  articles: [ARTICLE_CONTENT_KEYS.ROUTING],
  helpCenterLink: 'https://calendly.com/help/calendly-routing',
}

const usersOverviewPage = {
  title: ARTICLE_CONTENT_KEYS.ADDING_USERS,
  videoId: 'bh9agqfgck',
  playVideoEventProps: buildPlayVideoFlowStepCompletedProps('admin_users'),
  articles: [ARTICLE_CONTENT_KEYS.ADDING_USERS],
  helpCenterLink: 'https://calendly.com/help/user-management',
}

const workflowsOverviewPage = {
  title: ARTICLE_CONTENT_KEYS.WORKFLOWS,
  videoId: 'dfufa0h7io',
  playVideoEventProps: buildPlayVideoFlowStepCompletedProps('workflows'),
  articles: [ARTICLE_CONTENT_KEYS.WORKFLOWS],
  helpCenterLink: 'https://calendly.com/help/workflows-overview',
}

const schedulingOverviewPage = {
  title: ARTICLE_CONTENT_KEYS.SCHEDULING,
  tabs: {
    meeting_types: {
      articles: [ARTICLE_CONTENT_KEYS.MEETING_TYPES],
      helpCenterLink: 'https://calendly.com/help/event-types-overview',
    },
    single_use_links: {
      articles: [ARTICLE_CONTENT_KEYS.SINGLE_USE_LINKS],
      helpCenterLink: 'https://calendly.com/help/how-to-create-a-single-use-link',
    },
    polls: {
      articles: [ARTICLE_CONTENT_KEYS.POLLS],
      helpCenterLink: 'https://calendly.com/help/how-to-set-up-a-meeting-poll',
    }
  }
}

const blockedSourcesOverviewPage = {
  title: ARTICLE_CONTENT_KEYS.BLOCKED_SOURCES,
  articles: [], // TODO: Add this back in when the link is live articles: [ARTICLE_CONTENT_KEYS.BLOCKED_SOURCES],
  helpCenterLink: 'https://calendly.com/help/how-to-block-someone-from-booking-with-you',
}

export const overviewContentMap = {
  [CONTENT_PAGES.adminDashboard]: adminDashboardOverviewPage,
  [CONTENT_PAGES.analyticsEvents]: analyticsOverviewPage,
  [CONTENT_PAGES.analyticsMeetings]: analyticsOverviewCapacityPage,
  [CONTENT_PAGES.analyticsRouting]: analyticsOverviewRoutingPage,
  [CONTENT_PAGES.contacts]: contactsOverviewPage,
  [CONTENT_PAGES.eventTypes]: eventTypesOverviewPage,
  [CONTENT_PAGES.groups]: groupsOverviewPage,
  [CONTENT_PAGES.managedEventTypes]: managedEventTypesOverviewPage,
  [CONTENT_PAGES.managedWorkflows]: managedWorkflowsOverviewPage,
  [CONTENT_PAGES.meetings]: meetingsOverviewPage,
  [CONTENT_PAGES.routingForms]: routingFormsOverviewPage,
  [CONTENT_PAGES.recaps]: recapsOverviewPage,
  [CONTENT_PAGES.recapsMIEnabled]: recapsOverviewPage,
  [CONTENT_PAGES.users]: usersOverviewPage,
  [CONTENT_PAGES.workflows]: workflowsOverviewPage,
  [CONTENT_PAGES.scheduling]: schedulingOverviewPage,
  [CONTENT_PAGES.meetingTypes]: schedulingOverviewPage,
  [CONTENT_PAGES.singleUseLinks]: schedulingOverviewPage,
  [CONTENT_PAGES.polls]: schedulingOverviewPage,
  [CONTENT_PAGES.blockedSources]: blockedSourcesOverviewPage,
}

const buildAnalyticsFlowStartedProps = (context) => ({
  flow_name: `contextual_help_${context}`,
  flow_step: 'guide_dismissed',
  completion_method: 'guide_dismissed',
  flow_step_value: null,
  flow_version: 'v1',
})
const closeOnAdminDashboardProps = buildAnalyticsFlowStartedProps('admin_dashboard')
const closeOnAnalyticsEventsProps = buildAnalyticsFlowStartedProps('analytics_events')
const closeOnAnalyticsCapacityProps = buildAnalyticsFlowStartedProps('analytics_capacity')
const closeOnAnalyticsRoutingProps = buildAnalyticsFlowStartedProps('analytics_routing')
const closeOnContactsProps = buildAnalyticsFlowStartedProps('contacts')
const closeOnEventTypesProps = buildAnalyticsFlowStartedProps('event_types')
const closeOnGroupsProps = buildAnalyticsFlowStartedProps('admin_groups')
const closeOnManagedEventsProps = buildAnalyticsFlowStartedProps('admin_managed_events')
const closeOnManagedWorkflowsProps = buildAnalyticsFlowStartedProps('admin_managed_workflows')
const closeOnMeetingsProps = buildAnalyticsFlowStartedProps('meetings')
const closeOnRoutingProps = buildAnalyticsFlowStartedProps('routing')
const closeOnUsersProps = buildAnalyticsFlowStartedProps('admin_users')
const closeOnWorkflowsProps = buildAnalyticsFlowStartedProps('workflows')
const closeOnMeetingTypesProps = buildAnalyticsFlowStartedProps('meeting_types')
const closeOnSingleUseLinksProps = buildAnalyticsFlowStartedProps('single_use_links')
const closeOnPollsProps = buildAnalyticsFlowStartedProps('polls')
const closeOnBlockedSourcesProps = buildAnalyticsFlowStartedProps('blocked_sources')

export const CLOSE_HELP_OVERVIEW_EVENT_PROPS = {
  [CONTENT_PAGES.adminDashboard]: {
    flowStepCompletedProps: { ...closeOnAdminDashboardProps }
  },
  [ARTICLE_CONTENT_KEYS.ADMIN_CENTER]: {
    flowStepCompletedProps: { ...closeOnAdminDashboardProps }
  },
  [CONTENT_PAGES.analyticsEvents]: {
    flowStepCompletedProps: { ...closeOnAnalyticsEventsProps }
  },
  [ARTICLE_CONTENT_KEYS.ANALYTICS]: {
    flowStepCompletedProps: { ...closeOnAnalyticsEventsProps }
  },
  [CONTENT_PAGES.analyticsMeetings]: {
    flowStepCompletedProps: { ...closeOnAnalyticsCapacityProps }
  },
  [ARTICLE_CONTENT_KEYS.ANALYTICS_CAPACITY]: {
    flowStepCompletedProps: { ...closeOnAnalyticsCapacityProps }
  },
  [CONTENT_PAGES.analyticsRouting]: {
    flowStepCompletedProps: { ...closeOnAnalyticsRoutingProps }
  },
  [ARTICLE_CONTENT_KEYS.ANALYTICS_ROUTING]: {
    flowStepCompletedProps: { ...closeOnAnalyticsRoutingProps }
  },
  [CONTENT_PAGES.contacts]: {
    flowStepCompletedProps: { ...closeOnContactsProps }
  },
  [ARTICLE_CONTENT_KEYS.CONTACTS]: {
    flowStepCompletedProps: { ...closeOnContactsProps }
  },
  [CONTENT_PAGES.eventTypes]: {
    flowStepCompletedProps: { ...closeOnEventTypesProps }
  },
  [ARTICLE_CONTENT_KEYS.EVENT_TYPES]: {
    flowStepCompletedProps: { ...closeOnEventTypesProps }
  },
  [CONTENT_PAGES.groups]: {
    flowStepCompletedProps: { ...closeOnGroupsProps }
  },
  [ARTICLE_CONTENT_KEYS.GROUPS]: {
    flowStepCompletedProps: { ...closeOnGroupsProps }
  },
  [CONTENT_PAGES.managedEventTypes]: {
    flowStepCompletedProps: { ...closeOnManagedEventsProps }
  },
  [ARTICLE_CONTENT_KEYS.MANAGED_EVENTS]: {
    flowStepCompletedProps: { ...closeOnManagedEventsProps }
  },
  [CONTENT_PAGES.managedWorkflows]: {
    flowStepCompletedProps: { ...closeOnManagedWorkflowsProps }
  },
  [ARTICLE_CONTENT_KEYS.MANAGED_WORKFLOWS]: {
    flowStepCompletedProps: { ...closeOnManagedWorkflowsProps }
  },
  [CONTENT_PAGES.meetings]: {
    flowStepCompletedProps: { ...closeOnMeetingsProps }
  },
  [ARTICLE_CONTENT_KEYS.MEETINGS]: {
    flowStepCompletedProps: { ...closeOnMeetingsProps }
  },
  [CONTENT_PAGES.routingForms]: {
    flowStepCompletedProps: { ...closeOnRoutingProps }
  },
  [ARTICLE_CONTENT_KEYS.ROUTING]: {
    flowStepCompletedProps: { ...closeOnRoutingProps }
  },
  [CONTENT_PAGES.users]: {
    flowStepCompletedProps: { ...closeOnUsersProps }
  },
  [ARTICLE_CONTENT_KEYS.ADDING_USERS]: {
    flowStepCompletedProps: { ...closeOnUsersProps }
  },
  [CONTENT_PAGES.workflows]: {
    flowStepCompletedProps: { ...closeOnWorkflowsProps }
  },
  [ARTICLE_CONTENT_KEYS.WORKFLOWS]: {
    flowStepCompletedProps: { ...closeOnWorkflowsProps }
  },
  [CONTENT_PAGES.meetingTypes]: {
    flowStepCompletedProps: { ...closeOnMeetingTypesProps }
  },
  [CONTENT_PAGES.singleUseLinks]: {
    flowStepCompletedProps: { ...closeOnSingleUseLinksProps }
  },
  [CONTENT_PAGES.polls]: {
    flowStepCompletedProps: { ...closeOnPollsProps }
  },
  [CONTENT_PAGES.blockedSources]: {
    flowStepCompletedProps: { ...closeOnBlockedSourcesProps }
  },
  [ARTICLE_CONTENT_KEYS.BLOCKED_SOURCES]: {
    flowStepCompletedProps: { ...closeOnBlockedSourcesProps }
  }
}
